import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{#if this.loading.showLoading}}\n  {{yield}}\n{{/if}}\n")